import React, { ChangeEvent, memo } from 'react'
import { Button, Input, InputCheck, SelectAnimalFetchInput, SelectInput } from 'src/components'
import { causesOptions, occurrenceOptions } from 'src/constants/deathFromDisease'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useStyles } from './styles'
import { formatDateToInputValue } from 'src/utils'
import { DeathsAndDiseasesDto, UpdateDeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'
import { useRegister } from './hooks/useRegister'
import { VALIDATIONS } from 'src/@types/validations/'
import { FormattedOption } from 'src/dto/animal.dto'
interface AnimalFormDataRegisterProps {
  data: DeathsAndDiseasesDto | null
  onClose: () => void
  onOpen: () => void
}

const AnimalFormDataRegisterComponent = ({ data, onClose, onOpen }: AnimalFormDataRegisterProps) => {
  const {
    watch,
    setValue,
    clearErrors,
    handleSubmit,
    reset,
    formState: { errors, isDirty }
  } = useForm<UpdateDeathsAndDiseasesDto>({ resolver: yupResolver(VALIDATIONS.DeathsAndDiseases) })

  const { isLoading, onSubmit, handleKeyDown, multipleRegister, setMultipleRegister } = useRegister({
    data,
    handleSubmit,
    onOpen,
    onClose,
    reset
  })

  const style = useStyles()

  return (
    <form onSubmit={onSubmit} onKeyDown={handleKeyDown} className={style.formContainer}>
      <SelectAnimalFetchInput
        disabled={!!data?.id}
        label='Animal'
        selectBy='id'
        showBy={['cdn', 'nome']}
        value={watch('idAnimal') || ''}
        error={errors?.idAnimal?.message}
        hidden={['MT', 'VD']}
        placeholder='Selecionar Animal'
        onChange={(item: FormattedOption) => {
          setValue('idAnimal', item.id, { shouldDirty: true })
          clearErrors('idAnimal')
        }}
      />
      <Input
        type='date'
        label='Data'
        value={formatDateToInputValue(watch('data') || '')}
        error={errors?.data?.message}
        onChange={(item: string) => {
          setValue('data', item, { shouldDirty: true })
          clearErrors('data')
        }}
      />
      <SelectInput
        label='Ocorrência'
        selectBy='id'
        showBy={['value']}
        options={occurrenceOptions}
        value={watch('ocorrencia') || ''}
        error={errors?.ocorrencia?.message}
        placeholder='Selecionar Ocorrência'
        onChange={(item: FormattedOption) => {
          setValue('ocorrencia', item.id, { shouldDirty: true })
          clearErrors('ocorrencia')
        }}
      />
      <SelectInput
        label='Causa'
        selectBy='id'
        showBy={['value']}
        options={causesOptions}
        value={watch('causa') || ''}
        error={errors?.causa?.message}
        placeholder='Selecionar Causa'
        onChange={(item: FormattedOption) => {
          setValue('causa', item.id, { shouldDirty: true })
          clearErrors('causa')
        }}
      />
      <Input
        type='text'
        label='Observações'
        value={watch('observacao') || ''}
        error={errors?.observacao?.message}
        onChange={(item: string) => {
          setValue('observacao', item, { shouldDirty: true })
          clearErrors('observacao')
        }}
      />
      <div className='footerPopup'>
        <div className={style.formControl}>
          <InputCheck
            label='Cadastrar outra ocorrência'
            id='newRegister'
            value='multipleRegister'
            checked={multipleRegister}
            onChange={(event: ChangeEvent<HTMLInputElement>) => setMultipleRegister(event.target.checked)}
          />
        </div>
        <div className={style.formFooter}>
          <Button type='button' outlined onClick={onClose}>
            Cancelar
          </Button>
          <Button type='submit' disabled={!isDirty || isLoading} isLoading={isLoading}>
            {data?.id ? 'Atualizar' : 'Criar'}
          </Button>
        </div>
      </div>
    </form>
  )
}

export default memo(AnimalFormDataRegisterComponent)
